module.exports = __webpack_public_path__ + "assets/img/icon12-menu2.52df0764.svg";